module.exports = "/_next/static/fonts/ABCSocial-Bold-b55c423ef50ec1cb05658fac0a611efa.woff2";